var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppMigration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 -31 937.5 937",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62.5 750.25 L 93.75 750.25 L 93.75 719 L 62.5 719 C 45.238281 719 31.25 705.011719 31.25 687.75 L 31.25 62.75 C 31.25 45.488281 45.238281 31.5 62.5 31.5 L 750 31.5 C 767.261719 31.5 781.25 45.488281 781.25 62.75 L 781.25 94 L 812.5 94 L 812.5 62.75 C 812.5 28.234375 784.515625 0.25 750 0.25 L 62.5 0.25 C 27.984375 0.25 0 28.234375 0 62.75 L 0 687.75 C 0 722.265625 27.984375 750.25 62.5 750.25 Z M 62.5 750.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.5 62.75 L 93.75 62.75 L 93.75 94 L 62.5 94 Z M 62.5 62.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 62.75 L 156.25 62.75 L 156.25 94 L 125 94 Z M 125 62.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 62.75 L 218.75 62.75 L 218.75 94 L 187.5 94 Z M 187.5 62.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 812.75 C 125 847.265625 152.984375 875.25 187.5 875.25 L 875 875.25 C 909.515625 875.25 937.5 847.265625 937.5 812.75 L 937.5 187.75 C 937.5 153.234375 909.515625 125.25 875 125.25 L 187.5 125.25 C 152.984375 125.25 125 153.234375 125 187.75 Z M 156.25 187.75 C 156.25 170.488281 170.238281 156.5 187.5 156.5 L 875 156.5 C 892.261719 156.5 906.25 170.488281 906.25 187.75 L 906.25 812.75 C 906.25 830.011719 892.261719 844 875 844 L 187.5 844 C 170.238281 844 156.25 830.011719 156.25 812.75 Z M 156.25 187.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 187.75 L 218.75 187.75 L 218.75 219 L 187.5 219 Z M 187.5 187.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250 187.75 L 281.25 187.75 L 281.25 219 L 250 219 Z M 250 187.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 187.75 L 343.75 187.75 L 343.75 219 L 312.5 219 Z M 312.5 187.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 250.25 L 875 250.25 L 875 281.5 L 187.5 281.5 Z M 187.5 250.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 328.375 L 312.5 328.375 L 312.5 359.625 L 187.5 359.625 Z M 187.5 328.375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 390.875 L 281.25 390.875 L 281.25 422.125 L 187.5 422.125 Z M 187.5 390.875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 531.25 453.375 C 470.839844 453.375 421.875 502.339844 421.875 562.75 C 421.875 623.160156 470.839844 672.125 531.25 672.125 C 591.660156 672.125 640.625 623.160156 640.625 562.75 C 640.554688 502.375 591.625 453.445312 531.25 453.375 Z M 531.25 640.875 C 488.105469 640.875 453.125 605.894531 453.125 562.75 C 453.125 519.605469 488.105469 484.625 531.25 484.625 C 574.394531 484.625 609.375 519.605469 609.375 562.75 C 609.320312 605.875 574.375 640.820312 531.25 640.875 Z M 531.25 640.875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 781.25 515.875 C 781.25 507.242188 774.257812 500.25 765.625 500.25 L 724.328125 500.25 C 721.019531 489.984375 716.894531 479.996094 711.96875 470.40625 L 741.171875 441.222656 C 747.265625 435.117188 747.265625 425.230469 741.171875 419.125 L 674.875 352.828125 C 668.769531 346.734375 658.882812 346.734375 652.777344 352.828125 L 623.59375 382.015625 C 613.988281 377.109375 604.007812 372.984375 593.75 369.671875 L 593.75 328.375 C 593.75 319.742188 586.757812 312.75 578.125 312.75 L 484.375 312.75 C 475.742188 312.75 468.75 319.742188 468.75 328.375 L 468.75 369.671875 C 458.492188 372.984375 448.511719 377.109375 438.90625 382.015625 L 409.722656 352.828125 C 403.617188 346.734375 393.730469 346.734375 387.625 352.828125 L 321.328125 419.125 C 315.234375 425.230469 315.234375 435.117188 321.328125 441.222656 L 350.515625 470.40625 C 349.210938 472.964844 347.953125 475.53125 346.765625 478.125 C 343.46875 485.328125 340.601562 492.710938 338.171875 500.25 L 296.875 500.25 C 288.242188 500.25 281.25 507.242188 281.25 515.875 L 281.25 609.625 C 281.25 618.257812 288.242188 625.25 296.875 625.25 L 338.171875 625.25 C 341.480469 635.515625 345.605469 645.503906 350.53125 655.09375 L 321.328125 684.277344 C 315.234375 690.382812 315.234375 700.269531 321.328125 706.375 L 387.625 772.671875 C 393.730469 778.765625 403.617188 778.765625 409.722656 772.671875 L 438.90625 743.484375 C 448.511719 748.390625 458.492188 752.515625 468.75 755.828125 L 468.75 797.125 C 468.75 805.757812 475.742188 812.75 484.375 812.75 L 578.125 812.75 C 586.757812 812.75 593.75 805.757812 593.75 797.125 L 593.75 755.828125 C 604.007812 752.515625 613.988281 748.390625 623.59375 743.484375 L 652.777344 772.671875 C 658.882812 778.765625 668.769531 778.765625 674.875 772.671875 L 741.171875 706.375 C 747.265625 700.269531 747.265625 690.382812 741.171875 684.277344 L 711.96875 655.09375 C 716.894531 645.503906 721.019531 635.515625 724.328125 625.25 L 765.625 625.25 C 774.257812 625.25 781.25 618.257812 781.25 609.625 Z M 750 594 L 712.59375 594 C 705.46875 594 699.25 598.824219 697.46875 605.71875 C 693.476562 621.226562 687.324219 636.109375 679.1875 649.90625 C 675.566406 656.039062 676.5625 663.851562 681.59375 668.890625 L 708.011719 695.324219 L 663.824219 739.53125 L 637.390625 713.09375 C 632.347656 708.054688 624.535156 707.0625 618.398438 710.6875 C 604.601562 718.824219 589.726562 724.980469 574.21875 728.96875 C 567.324219 730.75 562.5 736.96875 562.5 744.09375 L 562.5 781.5 L 500 781.5 L 500 744.09375 C 500 736.96875 495.175781 730.75 488.28125 728.96875 C 472.773438 724.980469 457.898438 718.824219 444.101562 710.6875 C 437.964844 707.0625 430.152344 708.054688 425.109375 713.09375 L 398.675781 739.53125 L 354.488281 695.324219 L 380.90625 668.890625 C 385.9375 663.851562 386.933594 656.039062 383.3125 649.90625 C 375.175781 636.109375 369.023438 621.226562 365.03125 605.71875 C 363.25 598.824219 357.03125 594 349.90625 594 L 312.5 594 L 312.5 531.5 L 349.90625 531.5 C 357.03125 531.5 363.25 526.675781 365.03125 519.78125 C 367.554688 509.945312 370.957031 500.367188 375.191406 491.144531 C 377.632812 485.796875 380.34375 480.582031 383.3125 475.519531 C 386.921875 469.382812 385.933594 461.582031 380.90625 456.546875 L 354.488281 430.113281 L 398.675781 385.90625 L 425.109375 412.351562 C 430.152344 417.390625 437.964844 418.375 444.101562 414.746094 C 457.898438 406.617188 472.773438 400.453125 488.28125 396.464844 C 495.175781 394.6875 500 388.460938 500 381.347656 L 500 344 L 562.5 344 L 562.5 381.40625 C 562.5 388.53125 567.324219 394.75 574.21875 396.53125 C 589.726562 400.519531 604.601562 406.675781 618.398438 414.8125 C 624.535156 418.4375 632.347656 417.445312 637.390625 412.40625 L 663.824219 385.96875 L 708.011719 430.175781 L 681.59375 456.609375 C 676.5625 461.648438 675.566406 469.460938 679.1875 475.59375 C 687.324219 489.390625 693.476562 504.273438 697.46875 519.78125 C 699.25 526.675781 705.46875 531.5 712.59375 531.5 L 750 531.5 Z M 750 594 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 781.25 781.5 L 875 781.5 L 875 812.75 L 781.25 812.75 Z M 781.25 781.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMigration);
export default __webpack_public_path__ + "static/media/app-migration.140638b2b45f3d9e42fff25a4a85157e.svg";
export { ForwardRef as ReactComponent };